import * as Sentry from '@sentry/react';
import { captureExceptionsToSentry } from '~/helpers/exceptionHandler';

export default function log(
  level,
  message,
  extra = {},
  exception = null,
) {
  if (level.toLowerCase() === 'error') {
    if (exception) {
      captureExceptionsToSentry(exception, extra);
    } else {
      Sentry.captureMessage(message, 'error');
    }
  }
}
